// Russian versions of database content (products, categories, page texts) and legacy
// hard-coded storefront copy. The Ukrainian source text is the key; the dictionary is
// stored in MongoDB (collection `content_translations`) and served by
// GET /api/public/content-translations?lang=ru. Ukrainian stays the source of truth:
// with UA selected, or for any text without a translation, the original is shown.

let currentLang = 'uk';
let dictionary = new Map();
const listeners = new Set();

export const getContentLang = () => currentLang;

export function setContentLang(lang) {
  currentLang = lang === 'ru' ? 'ru' : 'uk';
  if (typeof document !== 'undefined') document.documentElement.lang = currentLang;
  listeners.forEach(fn => fn());
}

export function setContentDictionary(values) {
  dictionary = new Map(Object.entries(values || {}).filter(([uk, ru]) => typeof uk === 'string' && typeof ru === 'string' && ru.trim()));
  listeners.forEach(fn => fn());
}

export function subscribeContentLang(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

const UA_ONLY = /[А-Яа-яІіЇїЄєҐґ]/;

function lookup(text) {
  const direct = dictionary.get(text);
  if (direct !== undefined) return direct;
  const trimmed = text.trim();
  if (trimmed !== text) {
    const inner = dictionary.get(trimmed);
    if (inner !== undefined) return text.slice(0, text.indexOf(trimmed)) + inner + text.slice(text.indexOf(trimmed) + trimmed.length);
  }
  return undefined;
}

/** Translate one Ukrainian string for the current language; unknown text is returned unchanged. */
export function tr(text) {
  if (currentLang !== 'ru' || typeof text !== 'string' || !UA_ONLY.test(text)) return text;
  const found = lookup(text);
  if (found !== undefined) return found;
  // Attribute values are often comma-joined lists ("Кругле, Овальне"): translate each item.
  if (text.includes(', ')) {
    const parts = text.split(', ');
    const translated = parts.map(part => lookup(part) ?? part);
    if (translated.some((part, index) => part !== parts[index])) return translated.join(', ');
  }
  return text;
}

export const dateLocale = () => (currentLang === 'ru' ? 'ru-RU' : 'uk-UA');

export async function loadContentDictionary(lang, fetcher = globalThis.fetch) {
  if (lang !== 'ru') return {};
  const response = await fetcher('/api/public/content-translations?lang=ru');
  if (!response.ok) throw new Error('translations unavailable');
  const data = await response.json();
  return data && typeof data.values === 'object' && !Array.isArray(data.values) ? data.values : {};
}

/** Multi-line text (hero title): the dictionary holds single lines, so translate line by line. */
export function trLines(text) {
  return typeof text === 'string' && text.includes('\n') ? text.split('\n').map(line => tr(line)).join('\n') : tr(text);
}
